<template>
  <div class="value-compare">
    <div class="value-compare__labels">
      <span> {{ a.value }} {{ a.label }}</span>
      <span> {{ b.value }} {{ b.label }}</span>
    </div>
    <div class="value-compare__bar">
      <div
        class="value-compare__value value-compare__value--a"
        :style="{ width: `${aPercent}%` }"
      ></div>
      <div
        class="value-compare__value value-compare__value--b"
        :style="{ width: `${bPercent}%` }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ValueCompareBar',
  props: {
    a: {
      type: Object,
      required: true,
    },
    b: {
      type: Object,
      required: true,
    },
  },
  computed: {
    total() {
      return this.a.value + this.b.value;
    },
    aPercent() {
      return (this.a.value / this.total) * 100;
    },
    bPercent() {
      return (this.b.value / this.total) * 100;
    },
  },
};
</script>

<style lang="scss" scoped>
.value-compare {
  display: flex;
  flex-direction: column;

  &__labels {
    display: flex;
    justify-content: space-between;
    font-size: 1rem;
    margin-bottom: 4px;
  }

  &__bar {
    display: flex;
    width: 100%;
    border-radius: 4px;
    overflow: hidden;
  }

  &__value {
    height: 16px;
    justify-content: center;
    align-items: center;
    display: flex;
    white-space: nowrap;
    &--a {
      background: color('teal');
      color: color('teal', 'text');
    }
    &--b {
      background: color('secondary');
      color: color('secondary', 'text');
    }
  }
}
</style>
